import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Button } from '@material-ui/core';

const CannotApproveAlert = ({ show, handleAction }) => (
  show &&
  <Alert severity="warning">
    <AlertTitle><strong>Cannot Approve Inspection</strong></AlertTitle>
                    All field tests must be approved before inspection approval can be performed.
    <Button style={{ textAlign: 'right', justifyContent: 'left' }} onClick={handleAction}><strong>Show Actions</strong></Button>
  </Alert>
)

const NoActionsAlert = ({ show, handleAction }) => (
  show &&
  <Alert severity="info">
  <AlertTitle><strong>No actions</strong></AlertTitle>
    No actions available for this inspection at this time. You're able to view revisions and field tests, but will not be able to submit the review form.
  <Button style={{ textAlign: 'right', justifyContent: 'left' }} onClick={handleAction}><strong>Close Drawer</strong></Button>
</Alert>
)

export { CannotApproveAlert, NoActionsAlert };